import { Filters } from '../../types/filters';
import './datepicker-custom.css';
import { SearchFilter } from './SearchFilter';
import { InvestmentStagesFilter } from './InvestmentStagesFilter';
import { IndustriesFilter } from './IndustriesFilter';
import { InvestmentTimeFilter } from './InvestmentTimeFilter';
import { ExitsFilter } from './ExitsFilter';
import { InvestmentsFilter } from './InvestmentsFilter';
import { FundingFilter } from './FundingFilter';

interface FiltersSidebarProps {
  filters: Filters;
  onFiltersChange: (filters: Filters) => void;
  searchTerm: string;
  onSearchChange: (term: string) => void;
  allStages: string[];
  allIndustries: string[];
  maxInvestments: number;
  maxExits: number;
  maxFunding: number;
}

export function FiltersSidebar({
  filters,
  onFiltersChange,
  searchTerm,
  onSearchChange,
  allStages,
  allIndustries,
  maxInvestments,
  maxExits,
  maxFunding
}: FiltersSidebarProps) {
  function handleReset() {
    onFiltersChange({
      investmentStages: [],
      sectors: [],
      numInvestmentsRange: [0, maxInvestments],
      numExitsRange: [0, maxExits],
      hasIsraeliOffice: null,
      regions: [],
      investorTypes: [],
      employeeRange: [],
      operatingStatus: [],
      industries: [],
      numEmployeesRange: [],
      fundingRange: [0, maxFunding],
      countries: [],
      continents: [],
      founderSearch: '',
      investmentDateRange: ['', ''],
      onlyLeadInvestments: false,
      minExitValue: undefined,
      hasExits: false
    });
    onSearchChange('');
  }

  return (
    <div className="w-70 bg-white border-r border-gray-100 flex-shrink-0 flex flex-col h-full relative overflow-hidden">
      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        <div className="p-4 space-y-4 pb-16">
          <SearchFilter
            searchTerm={searchTerm}
            onSearchChange={onSearchChange}
          />

          <InvestmentStagesFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
            allStages={allStages}
          />

          <IndustriesFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
            allIndustries={allIndustries}
          />

          <InvestmentTimeFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
          />

          <ExitsFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
            maxExits={maxExits}
          />

          <InvestmentsFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
            maxInvestments={maxInvestments}
          />

          <FundingFilter
            filters={filters}
            onFiltersChange={onFiltersChange}
            maxFunding={maxFunding}
          />
        </div>
      </div>

      {/* Fixed Reset Button at Bottom */}
      <div className="sticky bottom-0 inset-x-0 p-2 bg-white border-t border-gray-100">
        <button
          onClick={handleReset}
          className="w-full px-2 py-2 text-sm font-medium text-gray-500 bg-gray-50 hover:bg-gray-100 rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200 flex items-center justify-center gap-2 transition-colors duration-200"
        >
          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-3.5 h-3.5">
            <path strokeLinecap="round" strokeLinejoin="round" d="M16.023 9.348h4.992v-.001M2.985 19.644v-4.992m0 0h4.992m-4.993 0l3.181 3.183a8.25 8.25 0 0013.803-3.7M4.031 9.865a8.25 8.25 0 0113.803-3.7l3.181 3.182m0-4.991v4.99" />
          </svg>
          Reset Filters
        </button>
        <div className="text-center mt-2">
          <a href="https://intail.ai" target="_blank" rel="noopener noreferrer" className="text-xs text-gray-400 hover:text-gray-500">© 2024 intail.ai</a>
        </div>
      </div>
    </div>
  );
} 